<script>
    export let value;
    export let id;
</script>

<label for="{id}">Message : </label>
<textarea id="{id}" name="{id}" placeholder="Écrivez votre message" bind:value="{value}"></textarea>